<template>
  <ul class="navbar-nav">
    <li :class="['nav-item', $route.path === '/' ? 'nav-item-button' : '']">
      <b-link to="/" class="nav-link" @click="closeMainMenu">{{ $t("home") }}</b-link>
    </li>
    <li class="nav-item dropdown"
      :class="{ 'nav-item': true, 'dropdown': navItem.dropMenu.length > 0, 'nav-item-button': navItem.linkTo === $route.path }"
      v-for="navItem of navItems" :key="navItem.id" @mouseenter="onMouseEnter(navItem.id)"
      @mouseleave="onMouseLeave(navItem.id)">
      <ClientOnly>
        <b-link :class="{ 'nav-link': true, 'dropdown-toggle': navItem.dropMenu.length > 0 }"
          v-bind="navItem.dropMenu.length > 0 ? { href: '#', role: 'button', 'aria-expanded': 'false' } : {}"
          v-if="navItem.dropMenu.length > 0" @click.stop="onClick(navItem.id, navItem.linkTo)">{{
            navItem.itemName
          }}</b-link>
        <b-link :class="{ 'nav-link': true, 'dropdown-toggle': navItem.dropMenu.length > 0 }"
          @click.stop="onClick(navItem.id, navItem.linkTo)" v-else>{{
            navItem.itemName
          }}</b-link>
      </ClientOnly>
      <HeaderSubmenu v-if="navItem.hasDropMenu" :menuArray="navItem.dropMenu" :collapseId="'submenu' + navItem.id"
        :id="navItem.id" @mouseenter.native="onSubmenuEnter(navItem.id)"
        @mouseleave.native="onSubmenuLeave(navItem.id)" />
    </li>
    <li :class="['nav-item', $route.path === '/filialen' ? 'nav-item-button' : '']">
      <b-link to="/filialen" class="nav-link" @click="closeMainMenu">{{ $t("branches") }}</b-link>
    </li>
    <li :class="['nav-item', $route.path.startsWith('/klantenservice') ? 'nav-item-button' : '']">
      <b-link to="/klantenservice" class="nav-link" @click="closeMainMenu">
        {{ $t('customer_service') }}
      </b-link>
    </li>

  </ul>
</template>

<script>
import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";
import HeaderSubmenu from "@/esf_antarctica_lederhosenland/core/components/header/HeaderSubmenu.vue";
export default {
  name: "Navbar",
  components: {
    ClientOnly,
    HeaderSubmenu
  },
  data: () => ({
    hoverTimeouts: {},
    isSubmenuHovered: {}
  }),
  computed: {
    navItems() {
      return this.$store.getters["menu/getMenuItems"];
    },
    staticMenu() {
      var menuData =
        this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
          "header_menu_static"
        );
      menuData.content = menuData.content
        .replace(/<\/?ul>/, "")
        .replace("<li>", '<li class="nav-item"><div class="nav-link">')
        .replace("</b-link></li>", "</b-link></div></li>")
        .replace("</a></li>", "</a></div></li>");
      Logger.debug("static menu", "navbar", menuData)();
      return menuData;
    },
  },
  methods: {
    onMouseEnter(id) {
      if (window.innerWidth > 991) {
        if (this.hoverTimeouts[id]) {
          clearTimeout(this.hoverTimeouts[id]);
          delete this.hoverTimeouts[id];
        }
        this.$store.commit("menu/updateMenuState", { id: id, state: true });
      }
    },
    onMouseLeave(id) {
      if (window.innerWidth > 991) {
        this.hoverTimeouts[id] = setTimeout(() => {
          if (!this.isSubmenuHovered[id]) {
            this.$store.commit("menu/updateMenuState", { id: id, state: false });
          }
          delete this.hoverTimeouts[id];
        }, 100);
      }
    },
    onSubmenuEnter(id) {
      this.$set(this.isSubmenuHovered, id, true);
      if (this.hoverTimeouts[id]) {
        clearTimeout(this.hoverTimeouts[id]);
        delete this.hoverTimeouts[id];
      }
      this.$store.commit("menu/updateMenuState", { id: id, state: true });

    },
    onSubmenuLeave(id) {

      this.$set(this.isSubmenuHovered, id, false);


      this.hoverTimeouts[id] = setTimeout(() => {
        this.$store.commit("menu/updateMenuState", { id: id, state: false });
        delete this.hoverTimeouts[id];
      }, 100);
    },

    onOver(id) {
      if (window.innerWidth > 991) {
        this.$store.commit("menu/updateMenuState", { id: id, state: true });
      }
    },
    onToggle(id) {
      if (window.innerWidth <= 991) {
        const vis = this.$store.getters["menu/getMenuItemState"](id);
        Logger.debug("onToggle id", "Navbar", vis.id)();
        Logger.debug("onToggle", "Navbar", vis.state)();

        if (vis.state == false) {
          this.$store.commit("menu/updateMenuState", { id: id, state: true });
        } else {
          this.$store.commit("menu/updateMenuState", { id: id, state: false });
        }
      }
    },
    onLeave(id) {
      if (window.innerWidth > 991) {
        this.$store.commit("menu/updateMenuState", { id: id, state: false });
      }
    },
    doMouseOver(id) {
      Logger.debug("Mouse Over", "Menu", id)();
    },
    onClick(id, route) {
      if (document && document.getElementById("main-nav") && document.getElementById("main-nav").classList) {
        document.getElementById("main-nav").classList.remove("show");
      }
      Logger.debug("onClick", "navbarContent", id)();
      Logger.debug("onClick", "navbarContent", route)();
      Logger.debug(
        "onClick menu item state",
        "navbarContent",
        this.$store.getters["menu/getMenuItemState"](id).state
      )();
      this.$store.commit("menu/updateMenuState", { id: id, state: false });
      Logger.debug(
        "onClick menu item state",
        "navbarContent",
        this.$store.getters["menu/getMenuItemState"](id).state
      )();
      this.$store.commit("menu/setNavBar", false);

      this.$router.push(route);
    },
    toggleNav(event) {
      this.$emit("clicked", event);
    },
    closeMainMenu() {
      if (document && document.getElementById("main-nav") && document.getElementById("main-nav").classList) {
        document.getElementById("main-nav").classList.remove("show");
      }
    }
  },
  beforeDestroy() {
    Object.values(this.hoverTimeouts).forEach(timeout => {
      clearTimeout(timeout);
    });
  }
};
</script>

<style lang="scss" scoped></style>
